import React, { useEffect, useRef, useState, forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
  Slide,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Hls from "hls.js";
import TelegramHomeShortcutButton from "./TelegramHomeShortcutButton";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TutorialVideoDialog = ({ open, onClose, videoUrl }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const videoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!open || !videoUrl) return;

    const timer = setTimeout(() => {
      if (!videoRef.current) return;
      let hls;

      if (Hls.isSupported()) {
        hls = new Hls({ enableWorker: true });
        hls.loadSource(videoUrl);
        hls.attachMedia(videoRef.current);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          setIsReady(true);
          videoRef.current.muted = true; // ✅ 禁音
          videoRef.current.play().catch(() => {});
        });
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        videoRef.current.src = videoUrl;
        videoRef.current.muted = true;
        videoRef.current.play().catch(() => {});
        setIsReady(true);
      }

      return () => {
        if (hls) hls.destroy();
      };
    }, 300);

    return () => clearTimeout(timer);
  }, [open, videoUrl]);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          bgcolor: "#000",
          borderRadius: fullScreen ? 0 : 3,
          overflow: "hidden",
        },
      }}
    >
      {/* 顶部栏 */}
      <AppBar
        sx={{
          position: "relative",
          bgcolor: "rgba(0,0,0,0.3)",
          backdropFilter: "blur(8px)",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{ ml: 2, flex: 1, color: "#fff", fontSize:14 }}
            variant="h6"
            noWrap
          >
            保存小程序到桌面
          </Typography>

          <Button
  variant="contained"
  size="small"
  sx={{
    bgcolor: "rgba(255,255,255,0.9)",
    color: "#000",
    fontWeight: 600,
    borderRadius: "999px",
    px: 2,
    textTransform: "none",
    "&:hover": { bgcolor: "#fff" },
  }}
  onClick={() => {
    const webApp = window.Telegram?.WebApp;
    const url = "https://t.me/setlanguage/zh-hans-beta";

    if (webApp?.openLink) {
      // 在 Telegram WebApp 内部打开（MiniApp 方式）
      webApp.openLink(url, true); // 第二个参数 true 表示在内置浏览器打开
    } else {
      // 如果不支持，降级用普通新标签打开
      window.open(url, "_blank");
    }
  }}
>
  中文翻译
</Button>


          <TelegramHomeShortcutButton/>
        </Toolbar>
      </AppBar>

      {/* 视频区域 */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: fullScreen ? "90vh" : "80vh", // ✅ 缩小10%
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#000",
        }}
      >
        <video
          ref={videoRef}
          muted
          playsInline
          controls
          preload="auto"
          style={{
            width: "auto",
            height: "100%",
            maxWidth: "100%",
            backgroundColor: "#000",
          }}
        />
      </Box>
    </Dialog>
  );
};

export default TutorialVideoDialog;
